<template>
  <CCard class="engagement pt-4">
    <!--<CRow>
      <CCol sm="12">
        <header class="contactInfo__header d-flex align-items-top">
          <h3 class="contactInfo__title font-weight-normal">
            {{ $t('audience.detailContact.engagement') }}
          </h3>
        </header>
      </CCol>
      <CCol sm="12">
        <div class="contactInfo__body p-0 mt-4 text-gray-700">
          <div v-if="loading" class="w-100 h-100 d-flex justify-content-center align-items-center">
            <CSpinner class="my-3" color="primary" />
          </div>

          <div v-else v-for="(info, index) in infos" :key="index" class="mb-4">
            <div class="d-flex align-items-center mb-4">
              <CIcon
                :title="info.campaignType"
                :name="`${info.campaignType.toLowerCase()}Full`"
                class="text-gray-600 mr-2"
                size="custom-size"
                :height="25"
                viewBox="0 0 32 32"
              />
              <h5 class="font-weight-normal ">{{ info.campaignType }}</h5>
            </div>
            <div class="engagement__chart d-flex justify-content-between">
              <div class="engagement__chartItem progress-group w-100">
                <div class="progress-group-header d-flex justify-content-between">
                  <span class="title progress-title text-uppercas">Sent Successfully</span>
                  <span class="ml-auto progress-title-percent font-weight-normal font-20">{{ info.statistics.sentSuccessfully }}%</span>
                </div>
                <div class="progress-group-bars">
                  <div class="progress progress-custom">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      :style="{ width: info.statistics.sentSuccessfully + '%' }"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="engagement__chartItem progress-group w-100">
                <div class="progress-group-header">
                  <span class="title progress-title text-uppercas ">OPEN RATE</span>
                  <span class="ml-auto progress-title-percent font-weight-normal font-20">{{ info.statistics.avgOpenRate }}%</span>
                </div>
                <div class="progress-group-bars">
                  <div class="progress progress-custom">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      :style="{ width: info.statistics.avgOpenRate + '%' }"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="engagement__chartItem progress-group w-100">
                <div class="progress-group-header">
                  <span class="title progress-title text-uppercas ">CLICK RATE</span>
                  <span class="ml-auto progress-title-percent c font-20">{{ info.statistics.avgClickRate }}%</span>
                </div>
                <div class="progress-group-bars">
                  <div class="progress progress-custom">
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      :style="{ width: info.statistics.avgClickRate + '%' }"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>-->
  </CCard>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  name: 'ContactEngagement',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      infos: [],
      loading: false,
      recipient: [],
      messages: [],
    }
  },

  methods: {
    getEngagement(recipientId) {
      this.messages = []
      this.loading = true
      services
        .getRecipientEngagement(this.$route.params.organizationId, recipientId)
        .then(({ data }) => {
          this.infos = data.data
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },

  computed: {
    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },
  },
  watch: {
    getterRecipient(newValues) {
      this.recipient = newValues
      this.getEngagement(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss">
.engagement {
  background: none;
  border: none;
  box-shadow: none !important;

  &__chart {
  }

  &__chartItem:nth-of-type(even) {
    padding: 0 2em;
  }

  .font-20 {
    font-size: 20px;
  }
}

.progress {
  &-custom {
    height: 0.3em;
    background: var(--gray-300);
  }

  &-group-header {
    text-transform: uppercase;
  }

  &-title {
    font-size: 14px;
  }

  &-title-percent {
  }
}
</style>
